//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import {Form, FormItem, Input, Divider} from 'element-ui'
import CyMobileLayout from '../../../components/mobile/CyMobileLayout'
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Divider)
export default {
  name: 'StockOutConfirmPlanList',
  components: {
    CyMobileLayout
  },
  data () {
    return {
      nowDate: '',
      planDate: '',
      hasNextTask: true,
      totalAmount: 0,
      recordList: [{}]
    }
  },
  mounted () {
    this.nowDate = this.$Utils.dateFormat(new Date(), 'yyyy-MM-dd')
    this.planDate = this.$Utils.dateFormat(new Date(), 'yyyy-MM-dd')
    this.queryPlanList(1)
  },
  methods: {
    queryPlanList: function (c) {
      let that = this
      if (c === 1) {
        that.planDate = this.$Utils.dateFormat(new Date(), 'yyyy-MM-dd')
      } else if (c === 2) {
        var dateTmp = new Date(that.planDate)
        dateTmp.setDate(dateTmp.getDate() - 1)
        that.planDate = this.$Utils.dateFormat(dateTmp, 'yyyy-MM-dd')
      } else if (c === 3) {
        var dateTmp1 = new Date(that.planDate)
        dateTmp1.setDate(dateTmp1.getDate() + 1)
        that.planDate = this.$Utils.dateFormat(dateTmp1, 'yyyy-MM-dd')
      } else if (c === 4) {
        that.planDate = ''
      }
      let url = '/wms/stockout/plan/getStockOutPlanListOfConfirm'
      that.$axiosWeb.post(url, null, {params: {planDate: that.planDate}}).then(function (res) {
        if (res.meta.success) {
          that.recordList = res.data.list
          that.totalAmount = res.data.amount
          that.hasNextTask = res.data.hasNextTask
        } else {
          that.$Msgbox.alert(res.meta.message, '查询失败')
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/wms/stockout/StockOutConfirmPlanList.vue